import {HttpModelConverter} from "../../../../../../../core/converter/httpModel.converter";
import {TreatmentJourneyStepFeedbackModel} from "./treatmentJourneyStepFeedback.model";
import {Injectable} from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class TreatmentJourneyStepFeedbackConverter extends HttpModelConverter<TreatmentJourneyStepFeedbackModel> {
    protected createInstance(): TreatmentJourneyStepFeedbackModel {
        return new TreatmentJourneyStepFeedbackModel();
    }

    protected enrichObject(result: TreatmentJourneyStepFeedbackModel, src: TreatmentJourneyStepFeedbackModel) {
    }

}